import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { getLearningTraining } from '../domains/resources/services/learningCenterService';
import { formatTrainingDuration, LearningTraining } from '../domains/resources/types';
import '../domains/resources/components/Resources.css';

const TrainingDetailPage: React.FC = () => {
  const { trainingId = '' } = useParams();
  const location = useLocation();
  const returnContext = location.state as { returnTo?: string; returnLabel?: string } | null;
  const returnTo = returnContext?.returnTo || '/app/resources';
  const returnLabel = returnContext?.returnLabel ? `Back to ${returnContext.returnLabel}` : 'Learning center';
  const [training, setTraining] = useState<LearningTraining | null>(null);
  const [loading, setLoading] = useState(true);
  const [shared, setShared] = useState(false);
  useEffect(() => { getLearningTraining(trainingId).then(setTraining).finally(() => setLoading(false)); }, [trainingId]);
  const share = async () => {
    const url = window.location.href;
    try { await navigator.clipboard.writeText(url); setShared(true); window.setTimeout(() => setShared(false), 1800); }
    catch { await window.appPrompt('Copy this lesson link:', url); }
  };
  if (loading) return <main className="learning-center"><p>Loading lesson…</p></main>;
  if (!training) return <main className="learning-center"><Link to="/app/resources">← Learning center</Link><h1>Lesson not found</h1></main>;
  return <main className="learning-center certification-detail">
    <Link className="certification-detail__back" to={returnTo}>← {returnLabel}</Link>
    <article className="training-reference">
      <div className="training-reference__heading"><div><span className="learning-center__eyebrow">Quick lesson · {formatTrainingDuration(training)}</span><h1>{training.title}</h1><p>{training.description}</p></div><button className="community-education__submit-button" onClick={share}>{shared ? 'Link copied!' : 'Share lesson'}</button></div>
      {training.learningObjective && <aside className="training-reference__objective"><strong>Learning objective</strong><p>{training.learningObjective}</p></aside>}
      {training.video?.url ? <video className="training-card__video" controls playsInline preload="metadata" src={training.video.url}/> : (
        <div className="training-card__video-missing" role="note">
          No tutorial video uploaded yet. Please read the notes for this part of the certification.
        </div>
      )}
      {training.writtenContent && (
        <div className="training-card__content" dangerouslySetInnerHTML={{ __html: training.writtenContent }}/>
      )}
      {training.linkUrl && <a className="training-card__link" href={training.linkUrl} target="_blank" rel="noreferrer">{training.linkLabel || 'Open resource'} ↗</a>}
      {(training.documents || []).map(file => <a className="training-card__resource" key={file.storagePath} href={file.url} target="_blank" rel="noreferrer">{file.name} ↗</a>)}
      <div className="training-reference__tags">{training.tags.map(tag => <span key={tag}>{tag}</span>)}</div>
    </article>
  </main>;
};
export default TrainingDetailPage;
